import { render, staticRenderFns } from "./PlatformFeeInfo.vue?vue&type=template&id=611d6eb0"
import script from "./PlatformFeeInfo.vue?vue&type=script&lang=js"
export * from "./PlatformFeeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports